<template>
    <div class="px-8 m-auto">
        <h1 class="text-center text-gray-700 dark:text-indigo-400 text-3xl">Painel Varejo Opinião</h1>
        <h1 class="text-center text-gray-500 dark:text-gray-400 text-lg">Entrar</h1>
        <form novalidate @submit.prevent="login()" class="mx-auto grid grid-cols-2 gap-x-2 gap-y-4 pt-8 w-full md:w-3/5" >
            <span class="col-span-2">
                <Input label="Email" type="email" v-model="state.email" :validation="v$.email"/>
            </span>
            <span class="col-span-2">
                <Input label="Senha" type="password" v-model="state.password" :validation="v$.password"/>
            </span>
            <p @click="$emit('clickToChange', 3)" class="cursor-pointer col-span-2 text-xs text-indigo-500">Esqueceu a senha?</p>
            <button type="submit" class="btn col-span-2 bg-indigo-700 h-10 rounded-md uppercase text-gray-50 flex items-center justify-center" :disabled="loading">
                <span v-if="loading" class="h-full w-auto">
                    <Spinner width="4"/>
                </span>
                <span v-else>ENTRAR</span>
            </button>
        </form>
    </div>
</template>

<script>
import Input from '@/components/Design/Input'
import { reactive } from '@vue/reactivity'
import useVuelidate from '@vuelidate/core'
import { emailValidator, passwordLogin } from '@/mixins/validators.js'
import axios from 'axios'
import {useStore,} from 'vuex'
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { displayNotification } from '../../mixins/notification'
import Spinner from '../Design/Spinner.vue'

export default {
    name: 'SignIn',
    components: {
        Input,
        Spinner
    },
    setup() {
        const store = useStore()   
        const router = useRouter()
        const loading = ref(false)
        
        if(store.getters['auth/authenticated'])
            router.push('/dashboard')


        const state = reactive({
            email: '',
            password: ''
        })

        const rules = {
            email: emailValidator(),
            password: passwordLogin('ola'),
        }
        
        const v$ = useVuelidate(rules, state)

        const response = ref(0)
        const login = async () => {
            loading.value = true
            // v$.value.$validate()
            await axios.get('/sanctum/csrf-cookie')
            try {
                const res = await store.dispatch('auth/login', {'email': state.email.valueOf(), 'password': state.password.valueOf()})
                displayNotification(res)
                router.push('/dashboard').catch(() => {})
            }catch(e) {
                displayNotification(e.response)
            }
            
            loading.value = false
        }

        return { 
            state,
            v$,
            loading,
            login
        }
    }
}
</script>

<style>

</style>
